import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function ProtectedRoute({ children, loginPath = "/Login" }) {
  const { user, accessToken } = useSelector((state) => state.auth);

  const isAuthenticated = user && accessToken;

  if (!isAuthenticated) {
    return <Navigate to={loginPath} replace />;
  }

  return children;
}

